module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;
  return _vm._c('div', [_vm._c('div', {
    staticClass: "main-content container-fluid"
  }, [_vm._c('div', {
    staticClass: "row"
  }, [_vm._c('div', {
    staticClass: "col-md-12"
  }, [_vm._c('PageHeader', {
    attrs: {
      "title": "Manage Users",
      "subtitle": ""
    }
  }), _vm._v(" "), _vm._c('Panel', {
    staticClass: "panel panel-default panel-border-color panel-border-color-primary"
  }, [_vm._c('div', {
    staticClass: "row"
  }, [_vm._c('div', {
    staticClass: "col-xs-12 xs-p-40"
  }, [_vm._c('p', [_vm._c('strong', [_vm._v("Download user CSVs")])]), _vm._v(" "), _vm._c('button', {
    staticClass: "btn btn-primary btn-xl",
    attrs: {
      "disabled": _vm.saving
    },
    on: {
      "click": function($event) {
        _vm.downloadUsers()
      }
    }
  }, [_vm._v("Download registered users")]), _vm._v(" "), _vm._c('button', {
    staticClass: "btn btn-warning btn-xl",
    attrs: {
      "disabled": _vm.saving
    },
    on: {
      "click": function($event) {
        _vm.downloadSubs()
      }
    }
  }, [_vm._v("Download newsletter subscribers")])])])])], 1)])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-2af068f2!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/admin/users/usermanager.vue
// module id = 639
// module chunks = 1